import { render } from "./StepThree.vue?vue&type=template&id=2fe5c8ff"
import script from "./StepThree.vue?vue&type=script&lang=js"
export * from "./StepThree.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__